import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  LayoutDashboard,
  Users,
  Package,
  Truck,
  Building2,
  BarChart3,
  MapPin,
  MessageSquare,
  ListChecks,
  Settings,
} from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const NAV_GROUPS = [
  {
    category: 'Main',
    items: [{ path: '/dashboard', icon: LayoutDashboard, label: 'Dashboard', access: 'dashboard' }],
  },
  {
    category: 'Operations',
    items: [
      { path: '/loads', icon: Package, label: 'Loads', access: 'loads' },
      { path: '/reload', icon: MapPin, label: 'ReLoad', access: 'reload' },
      { path: '/interactions', icon: MessageSquare, label: 'Notes', access: 'loads' },
      { path: '/workflows', icon: ListChecks, label: 'Workflows', access: 'loads' },
      { path: '/facilities', icon: Building2, label: 'Facilities', access: 'facilities' },
      { path: '/carriers', icon: Truck, label: 'Carriers', access: 'carriers' },
      { path: '/customers', icon: Users, label: 'Customers', access: 'customers' },
    ],
  },
  {
    category: 'Insights',
    items: [{ path: '/reports', icon: BarChart3, label: 'Reports', access: 'reports' }],
  },
  {
    category: 'System',
    items: [{ path: '/settings', icon: Settings, label: 'Settings', access: 'settings', adminOnly: true }],
  },
];

const Sidebar = () => {
  const location = useLocation();
  const { canAccess, isAdmin, isCustomer, isCarrier } = useAuth();

  const isVisible = (item) => {
    if (item.adminOnly && !isAdmin()) return false;
    if (isCustomer()) return item.access === 'loads' && item.path === '/loads';
    if (isCarrier()) return (item.access === 'loads' && item.path === '/loads') || item.access === 'reload';
    return canAccess(item.access);
  };

  const isActive = (path) => location.pathname === path || location.pathname.startsWith(`${path}/`);

  return (
    <nav className="nui-sidebar" data-testid="sidebar">
      <div className="nui-sidebar-header">
        <Link to="/dashboard" className="nui-brand" data-testid="sidebar-brand">
          Mila<span>TMS</span>
        </Link>
      </div>
      <div className="nui-sidebar-body">
        <ul className="nui-nav">
          {NAV_GROUPS.map((group) => {
            const items = group.items.filter(isVisible);
            if (!items.length) return null;
            return (
              <React.Fragment key={group.category}>
                <li className="nui-nav-item nui-nav-category">{group.category}</li>
                {items.map((item) => (
                  <li key={item.path} className={`nui-nav-item ${isActive(item.path) ? 'active' : ''}`}>
                    <Link to={item.path} className="nui-nav-link" data-testid={`nav-${item.label.toLowerCase()}`}>
                      <item.icon className="link-icon" />
                      <span className="link-title">{item.label}</span>
                    </Link>
                  </li>
                ))}
              </React.Fragment>
            );
          })}
        </ul>
      </div>
    </nav>
  );
};

export default Sidebar;
